import Image from 'app/Components/Shared/Image/image';


import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';

function Login(props) {
const [error, setError] = useState({idNumber: '', creditNumber4Digit: '', additionalIdNumber: '', password: '', paypalEmail: ''});
const [form, setForm] = useState({idNumber: '', creditNumber4Digit: '', additionalIdNumber: '', password: '', paypalEmail: ''});

  function onChange(type, value) {
    setForm(prevForm => ({
      ...prevForm,
      [type]: value
    }));
  }

  function validateForm() {
    let valid = true;
    let newErrors = {idNumber: '', creditNumber4Digit: '', additionalIdNumber: '', password: '', paypalEmail: ''};
    // Israeli ID / company (9-10 digits) or passport (e.g. AAB269234)
    const idNumberRegex = /^(\d{9,10}|[A-Za-z0-9]{6,12})$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.idNumber || !idNumberRegex.test(form.idNumber)) {
      newErrors.idNumber = 'ת.ז לא תקינה';
      valid = false;
    }
    if (!props.loginParam.isPaypalEmail && (!form.creditNumber4Digit || form.creditNumber4Digit.length !== 4)) {
      newErrors.creditNumber4Digit = 'אנא הכנס 4 ספרות אחרונות של אמצע תשלום';
      valid = false;
    }
    if (props.loginParam.isAdditionalId && !idNumberRegex.test(form.additionalIdNumber)) {
      newErrors.additionalIdNumber = 'ת.ז לא תקינה';
      valid = false;
    }
    if (props.loginParam.isAccountPassword && !form.password) {
      newErrors.password = 'סיסמה לא תקינה';
      valid = false;
    }
    if (props.loginParam.isPaypalEmail && !emailRegex.test(form.paypalEmail)) {
      newErrors.paypalEmail = 'כתובת מייל לא תקינה';
      valid = false;
    }

    setError(newErrors);
    return valid;
  }


  function onClickContinueButton() {
    const isValidate = validateForm();
    if (isValidate) {
      props.onClickButton(form);
    }
  }

  return (
    <div className='invoice-calls-details-Login-wrapper'>
      <Image src={require('./images/cellcom-logo.svg')} />
      <div className='header'>
        <h2>פירוט שיחות למנויים</h2>
        <h3>לשמירה על פרטיותך <br/>נא הזן את הפרטים הבאים</h3>
      </div>
      <div className='login-form'>
          <TextInput
            onChange={(e) => onChange('idNumber', e.target.value)}
            value={form.idNumber}
            placeholder='תעודת זהות או ח.פ.'
            type='text'
            autoComplete='off'
            required='required'
            error={error.idNumber}
          />
          {!props.loginParam.isPaypalEmail &&
          <TextInput
            onChange={(e) => onChange('creditNumber4Digit', e.target.value)}
            value={form.creditNumber4Digit}
            placeholder='4 ספרות אחרונות של אמצעי תשלום'
            type='number'
            autoComplete='off'
            required='required'
            error={error.creditNumber4Digit}
          />}
          {props.loginParam.isAdditionalId &&
          <TextInput
            onChange={(e) => onChange('additionalIdNumber', e.target.value)}
            value={form.additionalIdNumber}
            placeholder='ת.ז לקוח נוסף'
            type='text'
            autoComplete='off'
            required='required'
            error={error.additionalIdNumber}
          />}
          {props.loginParam.isAccountPassword &&
          <TextInput
            onChange={(e) => onChange('password', e.target.value)}
            value={form.password}
            placeholder='קוד זיהוי אישי'
            type='text'
            autoComplete='off'
            required='required'
            error={error.password}
          />}
          {props.loginParam.isPaypalEmail &&
          <TextInput
            onChange={(e) => onChange('paypalEmail', e.target.value)}
            value={form.paypalEmail}
            placeholder='כתובת מייל PayPal'
            type='email'
            autoComplete='off'
            required='required'
            error={error.paypalEmail}
          />}
        </div>
        {props.error && <div className='error'>{props.error}</div>}
        <BtnSubmit text='המשך' onclick={() => onClickContinueButton()} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
